export type LightboxLanguage = "en" | "zh" | "ms" | "ta" | "zh-Hant";

export type LightboxPubData = {
  pubId: string;
  language: LightboxLanguage;
  colors: Record<string, string>;
  logo: string;
};

export const PUB_CONFIGS: Record<string, LightboxPubData> = {
  st: {
    pubId: "stEpaper",
    language: "en",
    colors: {
      "color-primary": "#3368b2",
      "background-button": "#0c2b57",
      "color-text-heading": "#0c2b57",
    },
    logo: "st_logo.png",
  },
  bt: {
    pubId: "btEpaper",
    language: "en",
    colors: {
      "color-primary": "#007bad",
      "background-button": "#000000",
      "color-text-heading": "#000000",
    },
    logo: "bt_logo.png",
  },
  zb: {
    pubId: "zbEpaper",
    language: "zh",
    colors: {
      "color-primary": "#a80034",
      "background-button": "#a80034",
      "color-text-heading": "#a80034",
    },
    logo: "zb_logo.png",
  },
  bh: {
    pubId: "bhEpaper",
    language: "ms",
    colors: {
      "color-primary": "#447ab2",
      "background-button": "#01519c",
      "color-text-heading": "#01519c",
    },
    logo: "bh_logo.png",
  },
  tm: {
    pubId: "tmEpaper",
    language: "ta",
    colors: {
      "color-primary": "#b10442",
      "background-button": "#b10442",
      "color-text-heading": "#b10442",
    },
    logo: "tm_logo.png",
  },
  sm: {
    pubId: "smEpaper",
    language: "zh",
    colors: {
      "color-primary": "#a80034",
      "background-button": "#be0027",
      "color-text-heading": "#be0027",
    },
    logo: "sm_logo.png",
  },
  tabla: {
    pubId: "tablaEpaper",
    language: "en",
    colors: {
      "color-primary": "#b10442",
      "background-button": "#b10442",
      "color-text-heading": "#b10442",
    },
    logo: "tabla_logo.png",
  },
  bm: {
    pubId: "bmEpaper",
    language: "ta",
    colors: {
      "color-primary": "#b10442",
      "background-button": "#b10442",
      "color-text-heading": "#b10442",
    },
    logo: "",
  },
  mm: {
    pubId: "mmEpaper",
    language: "ta",
    colors: {
      "color-primary": "#b10442",
      "background-button": "#b10442",
      "color-text-heading": "#b10442",
    },
    logo: "",
  },
};
